
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/digital-turbine",
      function () {
        return require("private-next-pages/destinations/digital-turbine.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/digital-turbine"])
      });
    }
  